// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161022/js/" + chunkId + "." + {"44":"5299430c","225":"afd1260b","481":"e1bdaab3","486":"24c8e78c","770":"5f9b1fb0"}[chunkId] + ".0.935209752919205.chunk.js";
};